module.exports = __webpack_public_path__ + "img/banner1.20c2b397.jpg";